import TGASDK from '@/config/TGASDK'
import AuthContext from '@/context/AuthContext'
import useLinkTo from '@/hook/useLinkTo'
import { PopUpStore } from '@/store/PopupStore'
import React, { useContext, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import Avatar from '../Avatar'
import BackBtn from './BackBtn'
import Logo from './Logo'
import MenuBtn from './MenuBtn'
import Search from './Search'

const Header: React.FC<PropType> = () => {
  const { getLink, linkTo } = useLinkTo()
  const { pathname } = useLocation()
  const pendingAvatarNavigation = useRef(false)
  const { status } = useContext(AuthContext)
  const ucEnabled = TGASDK.context.appConfig.feature.uc.enabled

  useEffect(() => {
    pendingAvatarNavigation.current = false
  }, [pathname])

  const handleAvatarClick = () => {
    if (status === 'unready') {
      return
    }

    if (status === 'authorized') {
      if (pathname === getLink('/my/') || pendingAvatarNavigation.current) {
        return
      }

      pendingAvatarNavigation.current = true
      linkTo('/my/')
    } else {
      PopUpStore.setRegisterPopupVisible(true)
    }
  }

  return (
    <div className="flex h-full items-center gap-sm px-md">
      <div className="flex flex-shrink-0 flex-grow-0 justify-around">
        <div className="flex h-9 w-9 sm:hidden">
          <BackBtn />
        </div>
        <div className="flex h-9 w-9">
          <MenuBtn />
        </div>
      </div>
      <div className="flex flex-grow sm:flex-grow-0 justify-center">
        <Logo />
      </div>
      <div className="flex flex-shrink-0 flex-grow-0 basis-20 items-center justify-end sm:flex-grow">
        <Search />
        {ucEnabled && <Avatar className="w-8" onClick={handleAvatarClick} />}
      </div>
    </div>
  )
}

interface PropType {}

export default React.memo(Header)
